import { Disclosure } from "@headlessui/react";
import HeaderImage from "../../assets/image/Header-Image.svg"
import HeaderBackground from "../../assets/image/Header-Background.png"

export default function Header() {
    return (
        <div id="Header" className="relative h-[100vh]">
            <img src={HeaderBackground} alt="HeaderBackground" className="w-full h-full absolute top-0 left-0 -z-50" />
            <div className="h-full flex items-center justify-center flex-col pt-32 header:flex-row header:pt-0">
                <div className="text-white">
                    <h1 className="w-[320px] h-[239px] font-extrabold text-[64px] leading-[100%] font-Poppins header:w-[350px] header:h-[239px] header:text-[75px]"><span className="text-primary">Nafun</span> Smart Factory</h1>
                    <h2 className="w-[326px] h-[129px] font-light text-[36px] leading-[42px] font-Roboto header:w-[343px]">Surf the world while monitoring your factory</h2>
                </div>
                <img src={HeaderImage} alt="HeaderImage" className="w-[428px] h-[331px] header:w-[964px] header:h-[749px]" />
            </div>
        </div>
    )
}
